import { whiteColor } from '../../material-dashboard-pro-react.jsx';

import Background from '../../../img/allevaBackground01.png';

const pagesStyle = (theme) => ({
  wrapper: {
    height: 'auto',
    minHeight: '100vh',
    position: 'relative',
    top: '0',
  },
  fullPage: {
    padding: '120px 0',
    position: 'relative',
    minHeight: '100vh',
    display: 'flex!important',
    margin: '0',
    border: '0',
    color: whiteColor,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundSize: 'cover',
    backgroundPosition: 'center center',
    height: '100%',
    backgroundImage: `url(${Background})`,
    backgroundSize: 'cover',
    /*
    [theme.breakpoints.down("sm")]: {
      minHeight: "fit-content!important"
    },
    */
    '& footer': {
      position: 'absolute',
      bottom: '0',
      width: '100%',
      border: 'none !important',
    },
    /* KM: 20210710 moved background Image and Size to top level
     *     and commented out all the :before and :after stuff
     *     and it seemed to fix the problem of the form being hidden by the "background"
    '&:before': {
      // backgroundColor: "rgba(" + hexToRgb(blackColor) + ", 0.65)",
      backgroundImage: `new URL(${Background})`,
      backgroundSize: 'cover',
    },
    '&:before,&:after': {
      display: 'block',
      content: '""',
      position: 'absolute',
      width: '100%',
      height: '100%',
      top: '0',
      left: '0',
      zIndex: '2',
    },
    */
  },
});

export default pagesStyle;
